import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose, ExecutionResult } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import BannerForm from '../components/BannerForm';
import { createBannerVariables, BannerUrlTarget, createBanner } from '@api/graphql/types';
import Paths from '../paths';


type Props = {
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: createBannerVariables;
}

class BannerCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                name: '',
                active_from: null,
                active_to: null,
                url: '',
                url_target: BannerUrlTarget._self,
                image_url_desktop: '',
                image_url_mobile: '',
                is_active: true,
                priority: 0,
                banner_place_ids: [],
            },
        };
    }

    public onSubmit = (variables: createBannerVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createBanner, variables,
        });
    }

    private onRedirectFunction = (response: ExecutionResult<createBanner>) => {
        const id = response.data ? response.data.createBanner.id : undefined;
        if (id) {
            return `${Paths.banner}/${id}`;
        }
        return undefined;
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({id: 'module.banner.create.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            <BannerForm
                                formData={this.state.formData}
                                onSubmit={this.onSubmit}
                                redirectFunction={this.onRedirectFunction}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(BannerCreate);



// WEBPACK FOOTER //
// ./src/modules/Banner/pages/BannerCreate.tsx